export default "__VITE_ASSET__CrDTeQGJ__"